import { useEffect, useState } from 'react';
import OrdersApi from '../../../../../API/shipment/orders-api';
import ShipmentsApi from '../../../../../API/shipment/shipments-api';
import { MAP_SKLAD_NAME, MAP_SKLAD_RUS, TYPE_BUTTONS } from '../../../../../constans';
import { getDate } from '../../../../../utils';
import styles from './styles.module.scss';
import { PopUp, Row } from '../../../../../components/Basic/Blocks';
import { H2, H3 } from '../../../../../components/Basic/WrapsStyle';
import { Select } from '../../../../../components/Basic/Inputs';
import { Button } from '../../../../../components/Basic/Buttons';

const WbShipPopUp = ({ skladName = '', market = '', day = null, clickOk = () => { }, close = () => { } }) => {
  const [selectShipment, setSelectShipment] = useState(null);
  const [selectOrder, setSelectOrder] = useState(null);
  const [shipments, setShipments] = useState([]);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    ShipmentsApi.getShipments({ data: { status: 'not started', market: 'wb' } }).then((r) => setShipments(r.shipments));
    OrdersApi.getOrders({}).then((r) => setOrders(r.orders));
  }, []);

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2 style={{ marginBottom: '20px' }}>
        Собрать заказы {market} {day}?
      </H2>

      <H3 style={{ marginBottom: '20px' }}>Добавить в отгрузку</H3>

      <Select
        list={shipments.filter((item) => item.sklad === (skladName !== 'Не выбран' ? MAP_SKLAD_RUS[skladName] : MAP_SKLAD_NAME[market]))}
        select={selectShipment}
        label={'Отгрузка'}
        valueFn={(item) => (item ? `${item.market} ${getDate(item.time_scheduled)} ${item.sklad}` : null)}
        onSelect={(v) => setSelectShipment(v)}
      />

      {/* <H3 style={{ margin: '20px 0px' }}>Добавить в заказ</H3>
      <Select
        list={orders.filter(item => item.sklad_name === (skladName !== 'Не выбран' ? MAP_SKLAD_RUS[skladName] : MAP_SKLAD_NAME[market]))}
        select={selectOrder}
        label={'Заказ'}
        valueFn={(item) => (item ? `${getDate(item.dates.scheduled)} ${item.sklad_name}` : null)}
        onSelect={(v) => setSelectOrder(v)}
      />  */}

      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{
            marginRight: '15px',
          }}
          // disabled={selectShipment === null || selectOrder === null}
          disabled={selectShipment === null}
          onClick={() => clickOk(selectShipment.id, selectOrder?.id)}
        >
          Да
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default WbShipPopUp;
